import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";

const ApiKeyOperationList = () => {
  const [data, setData] = useState([]);
  const [subUserApiKeyOperationId, setsubUserApiKeyOperationId] = useState([]);
  const [message, setMessage] = useState("");
  const [publishInfo, setPublishInfo] = useState({}); // State to hold publish info

  const { getUrlByOperation } = useApiUrls();
  const navigate = useNavigate();
  // const localStorageData = JSON.parse(localStorage.getItem("user"));
  // const token = localStorageData?.token;
  // const userid = localStorageData?.userid;
  const token = getCookie("token");
    const userid = getCookie("userid");


  // Fetch catalog data
  const fetchCatalogAndCatelogData = async () => {
    try {
      const SubUserApiKeyOperationGetDistinct = getUrlByOperation("SubUserApiKeyOperationGetDistinct");

      // Fetch catalog data
      const catalogResponse = await axios.get('https://api.dqr-display-tms.bonrix.in/api/SubUserApiKeyOperation/SubUser/Get', {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      if (catalogResponse.data && Array.isArray(catalogResponse.data.data)) {
        setData(catalogResponse.data.data);
      }

      // Fetch Catelog data
      const CatelogResponse = await axios.get(`${SubUserApiKeyOperationGetDistinct}/SubUser/GetDistinct/apikey`, {
        headers: {
          accept: "text/plain",
          "X-Authorization": token,
          UserId: userid,
        },
      });
      if (CatelogResponse.data && Array.isArray(CatelogResponse.data.data)) {
        setsubUserApiKeyOperationId(CatelogResponse.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCatalogAndCatelogData();
  }, [getUrlByOperation, token, userid]);

  const handleRegenerate = async () => {
    try {
      const response = await axios.get(
        'https://api.dqr-display-tms.bonrix.in/api/SubUserApiKeyOperation/SubUser/Reset',
        {
          headers: {
            accept: 'text/plain',
            'X-Authorization': token,
            UserId: userid,
          },
        }
      );

      if (response.data && (response.data.isresponse || response.data.responsestatus === 'SUCCESS')) {
        setMessage('API Key regenerated successfully!');
        fetchCatalogAndCatelogData();
      } else {
        setMessage(response.data?.errormsg || 'Failed to regenerate API key.');
      }
    } catch (error) {
      console.error('Error regenerating API key:', error);
      setMessage('Failed to regenerate API key.');
    }
  };

  const handleAddPop = () => {
    navigate("/addapikeyoperation");
  };

  const handleUpdatePop = (id) => {
    navigate(`/updateapikeyoperation/${id}`);
  };

  const handleShowImagePop = (id) => {
    navigate(`/showapikeyoperation/${id}`);
  };

  const handlePreview = (id) => {
    const previewUrl = `/apikeyoperationpreview/${id}`;
    window.open(previewUrl, "_blank");
  };

  const encodeId = (id) => {
    const strId = id.toString();
    const base64Id = btoa(strId);
    return base64Id.substring(0, 10).padEnd(8, "0"); // Limit to 8-10 characters
  };

  const handlePublish = async (item) => {
    // Use publishid if available, otherwise fall back to encoded id
    const publishId = item.publishid && item.publishid.trim() !== '' 
      ? item.publishid 
      : encodeId(item.id);
      const type = "admin";
    
    const publishUrl = `${window.location.origin}/SMD/apikeyoperation/${type}/${publishId}`;
    setPublishInfo({ id: item.id, encodedUrl: publishUrl, encodedId: publishId });

    try {
      await navigator.clipboard.writeText(publishUrl);
      setMessage("URL copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy URL:", error);
    }
  };

  const handleDelete = async (id) => {

    try {
      const SubUserApiKeyOperationDelete = 'https://api.dqr-display-tms.bonrix.in/api/SubUserApiKeyOperation/SubUser/Delete';
      await axios.get(SubUserApiKeyOperationDelete, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setMessage("Data deleted successfully!");
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data");
    }
  };

  const handleToggle = async (item) => {
    const SubUserApiKeyOperationActive = 'https://api.dqr-display-tms.bonrix.in/api/SubUserApiKeyOperation/SubUser/Active';
    const SubUserApiKeyOperationDeactive = 'https://api.dqr-display-tms.bonrix.in/api/SubUserApiKeyOperation/SubUser/Deactive';
    const apiUrl = item.active
      ? SubUserApiKeyOperationDeactive
      : SubUserApiKeyOperationActive;


    try {
      await axios.get(apiUrl, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">API Key Operation</h1>
                <div>
                  <button type="button" className="btn btn-primary mr-2" onClick={handleRegenerate}>
                    <i className="fas fa-sync-alt mr-1"></i> Regenerate API Key
                  </button>
                  <button type="button" className="btn btn-success" onClick={handleAddPop}>
                    <i className="fas fa-plus mr-1"></i> Add API Key Operation
                  </button>
                </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body table-responsive p-0">
                      <table className="table table-hover table-striped">
  <thead className="thead-light">
    <tr>
      <th style={{width: '5%'}} className="text-center">Id</th>
      <th style={{width: '40%'}}>API Key</th>
      <th style={{width: '20%'}}>IP Address</th>
      <th style={{width: '20%'}} className="text-center">Action</th>
      <th style={{width: '15%'}} className="text-center">Active</th>
    </tr>
  </thead>
  <tbody>
    {data.map((item) => (
      <tr key={item.id}>
        <td className="text-center">{item.id}</td>
        <td>
          <strong>{item.apikey}</strong>
        </td>
        <td>{item.ip || "-"}</td>
        <td className="text-center">
          <div className="btn-group">
            <button 
              className="btn btn-sm btn-info mr-1" 
              onClick={handleRegenerate}
              title="Regenerate API Key"
            >
              <i className="fas fa-sync-alt"></i>
            </button>
            <button 
              className="btn btn-sm btn-warning mr-1" 
              onClick={() => handleUpdatePop(item.id)}
            >
              <i className="fas fa-edit"></i>
            </button>
            <button 
              className="btn btn-sm btn-danger mr-1" 
              onClick={() => handleDelete(item.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </td>
        <td className="text-center">
          <Switch 
            isOn={item.active} 
            handleToggle={() => handleToggle(item)} 
            id={item.id} 
          />
        </td>
      </tr>
    ))}
  </tbody>
</table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div style={{ position: "fixed", top: "20px", right: "10px", width: "25%", zIndex: "9999" }}>
          <div
            className={`alert ${message === "Data deleted successfully!" ? "alert-success" : "alert-danger"} d-flex align-items-center`}
            role="alert"
            style={{ marginBottom: "10px" }}
          >
            <div>{message}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApiKeyOperationList;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
